import React from "react";
import { Label } from "@fluentui/react/lib/Label";
import { SearchBar } from "../../generic/searchBar/SearchBar";
import { useSourceListPanel } from "./SourceListPanelHook";
import { SourceListItem } from "../../interfaces/SourceListItemObj";
import { SourceListItemView } from "../../generic/sourceListItem/SourceListItemView";
import { SourceTypeEnum } from "../../../api/models/source-type-enum";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { OperationCompletedPanel } from "../../layout/OperationCompletedPanel";

interface DocumentSourceListProps {
  headerName: string;
  sourceList: SourceListItem[];
}

export const SourceListPanel: React.FunctionComponent<DocumentSourceListProps> = (props) => {
  const { clonedList, classNames, filterItems } = useSourceListPanel(props);

  return (
    <>
      <div className={classNames.label}>
        <Label>{props.headerName}</Label>
      </div>
      <SearchBar onChangeValue={filterItems} />
      {clonedList.map((obj) => (
        // eslint-disable-next-line react/jsx-key
        <SourceListItemView obj={obj} source={obj.dbId ? SourceTypeEnum.TAGETIK : SourceTypeEnum.EXCEL} />
      ))}
      {clonedList.length === 0 && (
        <OperationCompletedPanel
          message={formatMessage("cof.editobject.message.anyfindsources")}
          alt={formatMessage("cof.editobject.message.anyfindsources")}
          icon="/assets/noObject.svg"
        />
      )}
    </>
  );
};
